<template>
  <div id="appindex">
    <Login v-if="showLogin"></Login>
  </div>
</template>
<script>
import ApiService from "@/services/API-services";
import cookies from "@/libs/utils/cookie.js";
import axios from "axios";

export default {
  name: "app",
  data() {
    return {
      loginName: "",
      loginPwd: "",
      showLogin: true,
    };
  },
  created() {
    // 语言处理
    const lang = cookies.getQueryString("lang");
    if (lang) cookies.setCookie("lang", lang);

    const token = cookies.getQueryString("token");
    if (token) {
      this.showLogin = false;
      this.handleTokenLogin(token);
      return;
    }

    const user = cookies.getQueryString("user");
    const pwd = cookies.getQueryString("pwd");
    if (user) {
      this.showLogin = false;
      this.loginName = window.atob(user);
      this.loginPwd = window.atob(pwd || "");
      this.login();
    }
  },
  methods: {
    // token 免登逻辑
    async handleTokenLogin(token) {
      try {
        const valid = await this.validateSSOToken(token);
        if (valid === true) {
          this.loginName = R_config.demoName;
          this.loginPwd = R_config.demoPwd;
          this.login();
        } else {
          this.showLogin = true;
          this.stripQueryFromUrl();
        }
      } catch (e) {
        this.showLogin = true;
        this.stripQueryFromUrl();
      }
    },
    async validateSSOToken(token) {
      try {
        const res = await axios.post(R_config.validToken, { Token: token });
        return res.data.data;
      } catch (e) {
        return false;
      }
    },
    // 公共登录逻辑
    login() {
      ApiService.user
        .loginOctopus({
          userAccount: this.loginName,
          password: this.loginPwd,
        })
        .then((res) => {
          if (res.code === 0) {
            localStorage.token = res.data.token;
            sessionStorage.setItem("octopus_token", res.data.token);
            this.$utils.setCookie("token", res.data.token);
            localStorage.user = JSON.stringify(res.data.user_info.UserEntity);
            this.stripQueryFromUrl();
            window.location.href = "/mains.html";
          }
        });
    },

    stripQueryFromUrl() {
      const url = new URL(window.location.href);
      ["token", "lang", "user", "pwd"].forEach((k) => url.searchParams.delete(k));
      window.history.replaceState(
        {},
        "",
        url.pathname + (url.search ? "?" + url.searchParams.toString() : "") + url.hash
      );
    },
  },
};
</script>

<style>
@import url("./../../common/css/scrollbar.css");
html,
body,
#appindex {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}
.flexR {
  display: flex;
  flex-direction: row;
  margin: 10px 0;
}
.flexR .flexgrow {
  flex-grow: 1;
}
.flexshrink {
  flex-shrink: 0;
}
.floatR {
  float: right;
}
.log-input input {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 2px;
}
.bot-btn .el-checkbox__inner {
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue